import { version } from '../../package.json';
import { MyStuffItem } from 'redux/types/account';

export const getPersistKey = (reducerName: string) => `babele/${version}/${reducerName}`;

export const removeMyStuffItemDescription = (item: MyStuffItem) => ({ ...item, description: '' });
